import React from 'react'

import { headed2SetupVars } from './headed2SetupVars'

export const pennsylvaniaSetupVars = {
  siteId: 'pennsylvania',
  pathPrefix: '/pa',
  topScreenshotUrl: '/images/pennsylvania/marketing/Mockup.png',
  menuHeader: "Discover Pennsylvania's Solution for:",
  appUrl: 'https://www.pacareerzone.org',
  freeEducatorAccountQuota: 50,
  appName: 'Pennsylvania CareerZone',
  logoImg: '/images/assets/pennsylvania/horizontal/dark.svg',
  webinar: {
    upcoming: {
      webinarSignupForm: 'e9b3b105-0728-4b56-9634-37da30faeb37',
      webinarDetails:
        'Have you wondered if the CareerZone Upgrade would make sense for your school or district? In this webinar we will review some of the key features of the CareerZone upgrade as well as possible funding sources.'
    }
  },
  webinarHistory: [
    {
      date: 'August 2021',
      sortableDate: new Date('8/19/2021'),
      title:
        'Pennsylvania CareerZone Webinar: Interview with Kirk Rearick, Armstrong School District',
      description:
        'Watch our August 2021 webinar to learn how to meet career readiness evidence requirements with PA CareerZone.',
      videoUrl:
        'https://h2-training.s3.amazonaws.com/Pennsylvania+CareerZone+Webinar_+Interview+with+Kirk+Rearick%2C+Armstrong+School+District+-+Fall+2021.mp4'
    },
    ...headed2SetupVars.webinarHistory
  ],
  headerTitle: `The Pennsylvania CareerZone`,
  headerTitleDescription: (
    <div>
      <p>
        The Pennsylvania CareerZone is a state-supported career exploration and planning
        system designed to support career and college readiness, district strategy, and
        transition planning.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you get:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      The <b>Pennsylvania CareerZone</b> is the <b>only</b> career readiness system
      sponsored and supported by the <b>Department of Education</b>. For over a decade the
      CareerZone has supported career readiness in Pennsylvania.
    </span>
  ),
  sponsorImg: `/images/pennsylvania/padoe_logo.png`,
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-PA@2x.png',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=1XVSqjEfgmoCxqgjcnKdi4ETop8-V7_qZ`,
  otherSites: [
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://ar.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/AR-Logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
